import React from 'react'
import { Card, LazyImage, Heading } from '@offerzen/pinata-shame'

import styles from './styles'

const ErrorCard = () => (
  <Card className={styles.card}>
    <LazyImage loader={() => import('../../../assets/grumpy-cat-sitting.svg')} alt="Grumpy cat" width={210} />
    <Heading>
      <span role="status">
        <strong>Something went wrong. How awful.</strong>
      </span>
    </Heading>
  </Card>
)

export default ErrorCard
